import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import RoutesConfig from "./RoutesConfig";
import Navbar from "./Navbar";

const App = () => {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <RoutesConfig />
      </div>
    </Router>
  );
};

export default App;
